module.exports = __webpack_public_path__ + "static/media/file-export.fb291ade.svg";